// extracted by mini-css-extract-plugin
export default {"root":"IconFavourite_root__Q42co","rootActive":"IconFavourite_rootActive__roOW5"};